import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import ApiGo from '../../../actions/ApiGo'
import PopConfirm from '../../popUp/PopConfirm';
import Archiving from './Archiving';
import { useDispatch } from 'react-redux';
import { ADD_RESPONSE, ADD_RESPONSE_JSON } from '../../../stores/reducer_add';

const BackUpSetting = (props) => {
  const { t } = useTranslation()
  const [DBlist, setDBlist] = useState([]);
  const [LogList, setLogList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  function toggleRefresh() { setRefresh(!refresh) }
  const [archivingBool, setArchivingBool] = useState(false);
  const dispatch = useDispatch();

  // db & log list
  useEffect(() => {
    ApiGo.getlist_db_archive()
      .then(res => { setDBlist(res.split("\n")) })
      .catch(err => { console.log(err); })
    ApiGo.getlist_log_archive()
      .then(res => { setLogList(res.split("\n")) })
      .catch(err => { console.log(err); })
  }, [refresh])

  // 手動執行 archive
  function toManualArchive() {
    setArchivingBool(true)
    ApiGo.getDb_archive()
      .then(res => {
        dispatch(ADD_RESPONSE({ status: res.status, statusText: res.statusText, type: "db_archive" }))
        toggleRefresh()
        setArchivingBool(false)
      })
      .catch(err => {
        setArchivingBool(false)
        dispatch(ADD_RESPONSE({ status: err.status, statusText: err.statusText, type: "db_archive" }))
        return err.response
      })
      .then(res => { dispatch(ADD_RESPONSE_JSON(res)) })
  }

  return (
    <div className="font-ml w-90">
      {archivingBool ? <Archiving /> : null}
      <div className='font-l margb-xxxs'>{t("ADMIN.BACKUP.BACKUP_LIST")}</div>
      <ArchiveList DBlist={DBlist} type={"DB"} refresh={toggleRefresh} />
      <ArchiveList DBlist={LogList} type={"log"} refresh={toggleRefresh} />

      <div className='w-100 margt-s margb-xxs fx-d-r fx-fsc'>
        <div className='font-l'>{t("ADMIN.BACKUP.MANUALLY_BACKUP")}</div>
        <div
          className='br-10 bgC-alert-EE w-10 fx-ccc pad-5 l b t r margl-xs shadow-xs'
          onClick={toManualArchive}
        >
          {t("ADMIN.BACKUP.IMPLEMENT")}
        </div>
      </div>

    </div>
  );
}
export default BackUpSetting;


function ArchiveList(props) {
  const { t, i18n } = useTranslation()
  const [pop, setPop] = useState({
    open: false,
    content: "",
    parameter: []
  });
  let DBlist = props.DBlist

  function calculateFileSize(_originalSize) {
    let afterCalc = Number(_originalSize)
    if (isNaN(afterCalc)) return _originalSize
    let counter = 0
    while (afterCalc >= 1024 && counter < 3) {
      afterCalc = afterCalc / 1024
      counter += 1
    }
    // 使用翻譯的單位
    const units = [
      t("ADMIN.BACKUP.SIZE_UNIT_BYTES"),
      t("ADMIN.BACKUP.SIZE_UNIT_KB"),
      t("ADMIN.BACKUP.SIZE_UNIT_MB"),
      t("ADMIN.BACKUP.SIZE_UNIT_GB")
    ]
    // 保留一位小數（如果非整數）
    const displaySize = Number.isInteger(afterCalc) ? afterCalc : afterCalc.toFixed(1)
    return `${displaySize} ${units[Math.min(counter, units.length - 1)]}`
  }

  function getDownloadLink(_fileName) {
    if (props.type === "DB") {
      ApiGo.getDownload_db_archive(_fileName)
        .then(res => { window.location.href = res })
        .catch(err => { console.log(err); })
    } else if (props.type === "log") {
      ApiGo.getDownload_log_archive(_fileName)
        .then(res => { window.location.href = res })
        .catch(err => { console.log(err); })
    }
  }
  function togglePop() {
    setPop({
      open: false,
      content: "",
      parameter: []
    })
  }
  function deleteLink(_fileName) {
    if (props.type === "DB") {
      ApiGo.delete_db_archive(_fileName)
        .then(res => { props.refresh(); })
        .catch(err => { console.log(err); })
    } else if (props.type === "log") {
      ApiGo.delete_log_archive(_fileName)
        .then(res => { props.refresh(); })
        .catch(err => { console.log(err); })
    }
  }

  // 日期格式化：根據 i18n.language
  function formatArchiveDate(dateObj) {
    try {
      const fmt = new Intl.DateTimeFormat(i18n.language || 'en', {
        year: 'numeric', month: '2-digit', day: '2-digit'
      })
      return fmt.format(dateObj)
    } catch (e) {
      return `${dateObj.getFullYear()}-${dateObj.getMonth() + 1}-${dateObj.getDate()}`
    }
  }

  function formatYearMonth(dateObj) {
    try {
      const fmt = new Intl.DateTimeFormat(i18n.language || 'en', { year: 'numeric', month: '2-digit' })
      return fmt.format(dateObj)
    } catch (e) {
      return `${dateObj.getFullYear()}-${dateObj.getMonth() + 1}`
    }
  }

  return (
    <div className="fx-d-c font-m bgC-white wid-admin-90 hig-auto br-20 shadow-s-noHover pad-5 t b pad-30 b margb-xxs">
      {pop.open ?
        <PopConfirm
          title={t("ADMIN.BACKUP.DELETE_FILE")}
          content={pop.content}
          hide={togglePop}
          callBack={deleteLink}
          parameter={pop.parameter}
        />
        : null
      }
      <div className="font-l margl-xxs h-100 margt-xxs">{(props.type === "DB") ? t("ADMIN.BACKUP.DATABASE") : t("ADMIN.BACKUP.LOG")}</div>
      <div className="fx-d-r font-ml w-100 pad-15 t b">
        <div className='w-20  margl-xs'>{t("ADMIN.BACKUP.FILENAME")}</div>
        <div className='w-30'>{t("ADMIN.BACKUP.CONTENT")}</div>
        <div className='w-10 fx-ccc'>{t("ADMIN.BACKUP.FILESIZE")}</div>
        <div className='w-15 fx-ccc'>{t("ADMIN.BACKUP.BACKUP_TIME")}</div>
        <div className='w-20 fx-ccc'>{t("ADMIN.BACKUP.IMPLEMENT")}</div>
      </div>
      {DBlist.map(res => {
        if (!res) return null
        let _row = res.split(" ").filter(col => col !== "")
        if (_row.length < 9) return null
        let _fileName = _row[8]
        if (_fileName === "logarchive") return null

        // 解析檔案名稱中的時間（原邏輯保留）
        let _content_time = _fileName.split(".")[0].split(/([0-9]+)/).filter((r, i) => (r !== "" && i < 4))
        let _UTC_constent_time = new Date(_content_time)
        if (isNaN(_UTC_constent_time.getTime())) {
          // fallback: 用當前時間避免 crash
          _UTC_constent_time = new Date()
        }
        let _archive_YM = formatYearMonth(_UTC_constent_time)
        let _archive_D = _UTC_constent_time.getDate()
        let _threeMonthAgo = new Date(_UTC_constent_time.getTime() - 7776000000)
        let _content = `${t("ADMIN.BACKUP.AUTO_BACKUP_FILE")} ( ${formatYearMonth(_threeMonthAgo)} to ${_archive_YM} )`
        // 判斷是否手動備份（沿用你的原本條件）
        if ((_content_time[2] !== 1) && (_row[7].split(":")[0] !== 0)) { _content = t("ADMIN.BACKUP.MANUALLY_BACKUP_FILE") }
        let _fileSize = calculateFileSize(_row[4])
        return (
          <div className="fx-d-r w-100  pad-15 t b row_hover" key={_fileName + _row[7]}>
            <div className='w-20  fx-fsc margl-xs'>{_fileName}</div>
            <div className='w-30 fx-fsc'>【{(props.type === "DB" ? t("ADMIN.BACKUP.DATABASE_LABEL") : t("ADMIN.BACKUP.LOG_LABEL"))}】 {_content}</div>
            <div className='w-10 fx-ccc'>{_fileSize}</div>
            <div className='w-15 fx-ccc'>{formatArchiveDate(_UTC_constent_time)} {_row[7]}</div>
            <div className='w-20 fx-d-r fx-ccc'>
              <div className='br-10 bgC-light w-30 fx-ccc pad-15 l r shadow-xs' onClick={() => { getDownloadLink(_fileName) }}>{t("ADMIN.BACKUP.DOWNLOAD")}</div>
              <div className='br-10 bgC-alert-EE w-30 fx-ccc pad-15 l r shadow-xs margl-xs' onClick={() => {
                setPop({
                  open: true,
                  content: t("ADMIN.BACKUP.DELETE_CONFIRM", { file: _fileName }),
                  parameter: [_fileName]
                })
              }}>{t("RESIDENTS.DELETE")}</div>
            </div>
          </div>
        )
      })}
    </div>
  )
}